import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Loader = () => {
    return (
        <div
            style={{
                height: "100vh",
                width: "100vw",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#000", // optional background color
            }}
        >
            <Spin
                indicator={<LoadingOutlined spin style={{ fontSize: 48, color: "white" }} />}
                size="large"
            />
        </div>
    );
};

export default Loader;
